import { Box, Stack, Typography } from "@mui/material";
import VideocamOffIcon from "@mui/icons-material/VideocamOff";

interface Video {
	url?: string;
	durationSeconds?: number;
}

interface Props {
	video?: Video;
	mode?: "view" | "review";
}

/**
 * Stub for VIDEO sub-events. Mobile capture lands in SIMS-4999; until that
 * ships there is no video data to render. Prop shape mirrors what the live
 * implementation will accept so SIMS-4988 doesn't need to change later.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const VideoPlayer = ({ video, mode }: Props) => {
	return (
		<Stack
			alignItems="center"
			spacing={1}
			sx={{
				p: 4,
				bgcolor: "action.hover",
				borderRadius: 1,
				color: "text.secondary",
			}}
		>
			<VideocamOffIcon fontSize="large" />
			<Typography variant="body2" align="center">
				Video review will land with mobile capture (SIMS-4999).
			</Typography>
			<Box />
		</Stack>
	);
};
